import React, { useEffect, useState } from "react";
import {
  Input,
  Modal,
  Button,
  Spin,
  message,
  DatePicker,
  Select,
  Upload,
} from "antd";
import {
  UploadOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function EditCourse() {
  const { id } = useParams();
 
   const navigate = useNavigate();

  // Auth info
  const token = localStorage.getItem("token");
  const fullName = localStorage.getItem("fullName");
  const role = (localStorage.getItem("role") || "").toUpperCase();

  useEffect(() => {
    if (!token || !fullName || !role) {
      navigate("/user/sign_in");
    }
  }, [token, fullName, role, navigate]);


  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

const [isThumbnailModalOpen, setIsThumbnailModalOpen] = useState(false);
const [thumbnailFile, setThumbnailFile] = useState(null);
const [thumbnailLoading, setThumbnailLoading] = useState(false);

  const [formData, setFormData] = useState({
    CourseName: "",
    ProgramName: "",
    BatchName: "",
    BatchType: "",
    CourseTiming: "",
    CourseType: "PUBLIC",
    BatchStartDate: null,
    BatchEndDate: null,
  });

  const [imageFile, setImageFile] = useState(null);
  const [previewImage, setPreviewImage] = useState("");

  useEffect(() => {
    fetchCourse();
  }, []);

  const fetchCourse = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/course/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {
        const c = res.data.data;

        setFormData({
          CourseName: c.CourseName,
          ProgramName: c.ProgramName,
          BatchName: c.BatchName,
          BatchType: c.BatchType,
          CourseTiming: c.CourseTiming,
          CourseType: c.CourseType,
          BatchStartDate: c.BatchStartDate ? dayjs(c.BatchStartDate) : null,
          BatchEndDate: c.BatchEndDate ? dayjs(c.BatchEndDate) : null,
          CourseUrl: c.CourseUrl,
        });

        setPreviewImage(c.CourseImageUrl);
      }
    } catch {
      message.error("Failed to load course");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

const handleThumbnailSelect = (file) => {

  setThumbnailFile(file);

  const preview = URL.createObjectURL(file);
  setPreviewImage(preview);

  return false;
};

  const handleUpdate = async () => {
  try {

    setSaving(true);

    const data = {
      CourseType: formData.CourseType,
      CourseUrl: formData.CourseUrl
    };

    if (formData.BatchStartDate) {
      data.BatchStartDate = formData.BatchStartDate.format("YYYY-MM-DD");
    }

    if (formData.BatchEndDate) {
      data.BatchEndDate = formData.BatchEndDate.format("YYYY-MM-DD");
    }

    const res = await axios.put(
      `${process.env.REACT_APP_API_URL}/course/update-course-details/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if(res.data.success) {
      toast.success("Course updated successfully");

    navigate(-1);
    }

  } catch (error) {

    toast.error("Update failed");

  } finally {

    setSaving(false);

  }
};

  const handleThumbnailUpdate = async () => {

  if (!thumbnailFile) {
    message.warning("Please select an image");
    return;
  }

  try {

    setThumbnailLoading(true);

    const formData = new FormData();
    formData.append("image", thumbnailFile);

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/course/upload-thumbnail/${id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    
    if(res.data.success) {
      toast.success("Thumbnail updated successfully");

    setIsThumbnailModalOpen(false);
    }

    

  } catch (err) {

    toast.error("Thumbnail update failed");

  } finally {

    setThumbnailLoading(false);

  }
};

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="min-h-screen p-10 bg-gray-50">

      <ToastContainer
                                    position="bottom-left"
                                    autoClose={5000}
                                    hideProgressBar={true}
                                    newestOnTop={false}
                                    closeOnClick
                                    rtl={false}
                                    pauseOnFocusLoss
                                    draggable
                                    pauseOnHover
                                    theme="dark"
                                    className="!mb-6 !ml-4"
                                    toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
                                  />

      {/* HEADER */}
      <div className="flex items-center gap-4 mb-10">
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)} />
        <div>
          <h1 className="text-2xl font-semibold text-gray-800">
            Edit Course
          </h1>
          <p className="text-sm text-gray-500">
            Only course visibility and schedule can be edited
          </p>
        </div>
      </div>

      <div className="grid gap-10 lg:grid-cols-3">

        {/* LEFT PANEL */}
        <div className="p-8 space-y-6 bg-white border shadow-sm lg:col-span-2 rounded-xl">

          {/* COURSE INFO (READ ONLY) */}

          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-700">
              Course Information
            </h3>

            <Input
  value={formData.CourseName}
  readOnly
  className="bg-gray-100 cursor-not-allowed"
/>

<Input
  value={formData.ProgramName}
  readOnly
  className="bg-gray-100 cursor-not-allowed"
/>

<div className="grid gap-4 md:grid-cols-2">
  <Input
    value={formData.BatchName}
    readOnly
    className="bg-gray-100 cursor-not-allowed"
  />

  <Input
    value={formData.BatchType}
    readOnly
    className="bg-gray-100 cursor-not-allowed"
  />
</div>

<Input
  value={formData.CourseTiming}
  readOnly
  className="bg-gray-100 cursor-not-allowed"
/>
          </div>

          {/* EDITABLE SETTINGS */}

<div className="pt-4 space-y-4 border-t">

  <h3 className="text-lg font-semibold text-gray-700">
    Editable Settings
  </h3>

  {/* COURSE TYPE */}
  <div>
    <label className="text-sm text-gray-600">
      Course Visibility
    </label>

    <Select
      value={formData.CourseType}
      onChange={(v) => handleChange("CourseType", v)}
      className="w-full mt-1"
      options={[
        { label: "PUBLIC", value: "PUBLIC" },
        { label: "PRIVATE", value: "PRIVATE" },
      ]}
    />
  </div>

  {/* ✅ COURSE URL */}
  <div>
  <label className="text-sm text-gray-600">
    Course URL
  </label>

  <Input
    value={formData.CourseUrl}
    onChange={(e) => handleChange("CourseUrl", e.target.value)}
    className="w-full mt-1"
  />
</div>

  {/* DATES */}
  <div className="grid gap-4 md:grid-cols-2">

    <div>
      <label className="text-sm text-gray-600">
        Batch Start Date
      </label>

      <DatePicker
        value={formData.BatchStartDate}
        onChange={(d) => handleChange("BatchStartDate", d)}
        className="w-full mt-1"
      />
    </div>

    <div>
      <label className="text-sm text-gray-600">
        Batch End Date
      </label>

      <DatePicker
        value={formData.BatchEndDate}
        onChange={(d) => handleChange("BatchEndDate", d)}
        className="w-full mt-1"
      />
    </div>

  </div>

  {/* IMAGE */}
  <div className="pt-4">
    <Button
      className="font-semibold text-white bg-green-500 border-t"
      icon={<UploadOutlined />}
      onClick={() => setIsThumbnailModalOpen(true)}
    >
      Change Thumbnail
    </Button>
  </div>

  {/* BUTTONS */}
  <div className="flex gap-4 pt-4">
    <Button
      type="primary"
      loading={saving}
      onClick={handleUpdate}
    >
      Update Changes
    </Button>

    <Button onClick={() => navigate(-1)}>
      Cancel
    </Button>
  </div>

</div>
        </div>

        {/* PREVIEW */}

        <div className="p-6 bg-white border shadow-sm rounded-xl">

          <h3 className="mb-4 text-lg font-medium text-gray-700">
            Course Preview
          </h3>

          <img
            src={
              previewImage ||
              "https://via.placeholder.com/400x250"
            }
            alt="Preview"
            className="object-cover w-full h-48 mb-4 rounded-lg"
          />

          <h4 className="font-semibold text-gray-800">
            {formData.CourseName}
          </h4>

          <p className="text-sm text-gray-500">
            {formData.ProgramName}
          </p>

          <p className="mt-2 text-sm text-gray-600">
            {formData.BatchName} - {formData.BatchType}
          </p>

          <p className="text-sm text-gray-600">
            {formData.CourseTiming}
          </p>

          <p className="mt-3 text-sm font-medium text-blue-600">
            {formData.CourseType}
          </p>

        </div>
      </div>

      {/* THUMBNAIL MODAL */}

<Modal
  title="Change Course Thumbnail"
  open={isThumbnailModalOpen}
  onCancel={() => setIsThumbnailModalOpen(false)}
  footer={null}
  centered
  width={600}
>

  <div className="space-y-6">

    {/* COURSE DETAILS */}
    <div className="p-4 border rounded-lg bg-gray-50">

      <h3 className="mb-3 text-sm font-semibold text-gray-600">
        Course Information
      </h3>

      <div className="grid grid-cols-2 gap-3 text-sm">

        <div>
          <p className="text-gray-400">Course</p>
          <p className="font-medium text-gray-700">
            {formData.CourseName}
          </p>
        </div>

        <div>
          <p className="text-gray-400">Program</p>
          <p className="font-medium text-gray-700">
            {formData.ProgramName}
          </p>
        </div>

        <div>
          <p className="text-gray-400">Batch</p>
          <p className="font-medium text-gray-700">
            {formData.BatchName}
          </p>
        </div>

        <div>
          <p className="text-gray-400">Batch Type</p>
          <p className="font-medium text-gray-700">
            {formData.BatchType}
          </p>
        </div>

        <div>
          <p className="text-gray-400">Timing</p>
          <p className="font-medium text-gray-700">
            {formData.CourseTiming}
          </p>
        </div>

        <div>
          <p className="text-gray-400">Visibility</p>
          <p className="font-medium text-blue-600">
            {formData.CourseType}
          </p>
        </div>

      </div>

    </div>


    {/* CURRENT THUMBNAIL */}
    <div>

      <p className="mb-2 text-sm text-gray-500">
        Current Thumbnail
      </p>

      <img
        src={
          previewImage ||
          "https://via.placeholder.com/400x250"
        }
        alt="preview"
        className="object-cover w-full h-48 border rounded-lg"
      />

    </div>


    {/* IMAGE SELECT */}
    <Upload
      beforeUpload={handleThumbnailSelect}
      showUploadList={false}
      accept="image/*"
    >
      <Button icon={<UploadOutlined />}>
        Select New Image
      </Button>
    </Upload>


    {/* UPDATE BUTTON */}
    <Button
      type="primary"
      block
      size="large"
      loading={thumbnailLoading}
      onClick={handleThumbnailUpdate}
    >
      Update Thumbnail
    </Button>

  </div>

</Modal>
    </div>
  );
}

export default EditCourse;